//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('docArticlePorus', {
//        templateUrl: 'views/components/views/docArticlePorus/docArticlePorus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'docArticlePorusService', function ($stateParams, docArticlePorusService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let docArticleKeyno = $stateParams.docarticle_keyno;
            
//    		vm.model = {
//    			itemsListReadActivities: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadReadActivities() {
//                vm.model.itemsListReadActivities = await docArticlePorusService.listReadActivities({ docarticle_keyno: docArticleKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadReadActivities();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
